import React from "react";

export default function Embed({ children }) {
  return (
    <div className=" bg-gray-100 min-h-screen px-12 py-3 w-full">
      {children}
    </div>
  );
}
